import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from '../../../../services/auth.service';
import { SharedService } from 'src/app/services/shared.service';
import { CryptoService } from '../../../../services/crypto.service';

@Component({
  selector: 'form-bank',
  templateUrl: './bank.component.html',
  styleUrls: ['./bank.component.scss']
})
export class FormBankComponent implements OnInit {
  static ACCOUNT_TYPE_NORMAL: string = '普通';
  static ACCOUNT_TYPE_STANDARD: string = '当座';
  errors: string[] = [];
  types = [FormBankComponent.ACCOUNT_TYPE_NORMAL, FormBankComponent.ACCOUNT_TYPE_STANDARD];
  isCompleted: boolean = false;

  @Input() bankForm: any;
  @Input() hasRed: any;

  constructor(
    public auth: AuthService,
    private crypto: CryptoService
  ) {}

  ngOnInit() {
  }

  hasError(value: string): boolean {
    return this.errors.indexOf(value) >= 0;
  }

  changeStatusLabel(bank) {
    if (bank.status === 'review') return '変更申請中'
    if (bank.status === 'approve') return '承認済み'
    if (bank.status === 'reject') return '承認不可'

    return '変更未申請'
  }

  canSave() {
    if (this.bankForm.bank_name === '' || this.bankForm.branch_code === '' || this.bankForm.account_type === '' || this.bankForm.account_number === '' || this.bankForm.account_name === '') {
        return false;
    }

    return true;
  }

  doBankTempAction(params) {
    params = Object.assign({}, params.change)

    delete params.change
    return params
  }

  save() {
    this.errors = []
    if (this.validJapanese(this.bankForm.account_name) === false) {
      this.errors.push('invalid-account-name');
      return;
    }

    if (SharedService.validBankNumber(this.bankForm.account_number) === false) {
      this.errors.push('invalid-account-number');
      return;
    }

    this.isCompleted = false;

    let bank = undefined
    if (this.auth.user.status === AuthService.VTUBER_COMPLETD_STATUS) {
      bank = Object.assign({}, this.auth.user.bank)
      delete bank.change
      delete this.bankForm.change
      bank.change = this.bankForm

      bank = this.doBankTempAction(bank)
    } else {
      bank = Object.assign({}, this.bankForm)
      delete bank.change
    }

    bank.account_name = this.crypto.encrypt(bank.account_name)
    bank.account_number = this.crypto.encrypt(bank.account_number)
    bank.account_type = this.crypto.encrypt(bank.account_type)
    bank.bank_name = this.crypto.encrypt(bank.bank_name)
    bank.branch_code = this.crypto.encrypt(bank.branch_code)

    let params = {
        uid: this.auth.user.uid,
        bank: bank
    }

    this.auth.updateUserData(params)
    .then(() => {
      this.auth.getUser().then(res => {
        this.auth.setUser(res);
        this.isCompleted = true;
        this.decrypt();

        let self = this
        setTimeout(function() {
          self.isCompleted = false;
        }, 2000);
      })
    })
  }

  decrypt() {
    this.bankForm = Object.assign({}, this.auth.user.bank)
    this.bankForm.account_name = this.crypto.decrypt(this.bankForm.account_name)
    this.bankForm.account_number = this.crypto.decrypt(this.bankForm.account_number)
    this.bankForm.account_type = this.crypto.decrypt(this.bankForm.account_type)
    this.bankForm.bank_name = this.crypto.decrypt(this.bankForm.bank_name)
    this.bankForm.branch_code = this.crypto.decrypt(this.bankForm.branch_code)
  }

  validJapanese(str) {
    let regex = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g;

    return regex.test(str)
  }
}
